import React from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css"; // default theme styles
import "./rich-editor.css"
export default function SpecialRichEditor({
  isOpen,
  onClose,
  answerText,
  setAnswerText,
  answerDescription,
  setAnswerDescription,
  onSave
}) {
  if (!isOpen) return null;

  return (
    <div className="modalOverlay">
      <div className="modal">
        <h3 className="modalTitle">Add Answer</h3>

        {/* Answer text input */}
        <div className="input_wrap">
          <label style={{ display: "block", marginBottom: "5px" }}>
            Answer Text*
          </label>
          <input
            type="text"
            value={answerText}
            onChange={(e) => setAnswerText(e.target.value)}
            placeholder="Enter answer text"
            className="input_box"

          />
        </div>

        {/* Rich text editor */}
        <div className="description_wrap">
        <div style={{ width: "100%", marginBottom: "15px" }}>
          <label style={{ display: "block", marginBottom: "5px" }}>
            Description (optional)
          </label>
          <ReactQuill
            theme="snow"
            value={answerDescription}
            onChange={(html) => setAnswerDescription(html)} // html string
            placeholder="Enter description for this answer"
            // style={{ minHeight: "150px" }}
            className="descriptionArea"
          />
        </div>

        {/* Actions */}
        <div className="modalActions">
          <button className="modalCancel" onClick={onClose}>
            Cancel
          </button>
          <button
            className="modalConfirm"
            onClick={onSave}
            disabled={!answerText.trim()}
          >
            Save Answer
          </button>
        </div>

        </div>
      </div>
    </div>
  );
}
